import { ListItemAction } from 'wix-style-react';
import * as React from 'react';
import s from './header-desktop-languages-popover-content.scss';
import { getLanguagesForMenu } from './languages';
import { useConfigContext } from '../../../../../../config-context';
import { getLanguageLinkHref } from './utils';
export var HeaderDesktopLanguagesPopoverContent = function (_a) {
    var isLoggedIn = _a.isLoggedIn, showLanguages = _a.showLanguages;
    var locale = useConfigContext().locale;
    return (React.createElement("div", { className: s.popoverContentContainer }, getLanguagesForMenu(locale, showLanguages).map(function (language) {
        var languageCode = language.languageCode, text = language.text;
        var linkHref = getLanguageLinkHref(isLoggedIn, languageCode);
        return (React.createElement(ListItemAction, { title: text, as: "a", key: languageCode, size: "small", skin: "dark", href: linkHref, className: s.language, dataHook: "language-link-" + languageCode }));
    })));
};
//# sourceMappingURL=header-desktop-languages-popover-content.js.map